import './App.css';

function App() {

  const regions = [
    {
      name: "Deutschland",
      colors: ["#000", "#DD0000", "#FFCE00"],
      url: "https://booking.rentabox24.de/booking"
    },
    {
      name: "Österreich",
      colors: ["#ED2939", "#FFFFFF", "#ED2939"],
      url: "https://booking.rentabox24.at/booking"
    },
    {
      name: "Polska",
      colors: ["#FFFFFF", "#DC143C"],
      url: "https://booking.rentabox24.pl/booking"
    },
  ];

  const handleClick = (url) => {
    const currentQuery = window.location.search;

    window.location.href = `${url}${currentQuery}`
  };

  return (
    <div className="container">
      {regions.map(({ name, colors, url }) => (
        <div key={name} className="flag-button" onClick={() => handleClick(url)}>
          {colors.map((color, index) => (
            <div
              key={index}
              className="flag-stripe"
              style={{
                backgroundColor: color,
                height: `${(100 / colors.length)}%`,
                borderBottom: `1px solid ${color}`
              }}
            />
          ))}
          <div className="region-label">{name}</div>
        </div>
      ))}
    </div>
  );
}

export default App;
